export default {
    "baseURL": "http://127.0.0.1:3015",
}



// WEBPACK FOOTER //
// ./src/config/config.js